import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 首页 测试参数tenantCode=dev&token=devH5Toekn1234567890
  {
    path: '/',
    redirect: '/Home',
  },
  {
    path: '/home',
    name: 'Home',
    title: '今日菜价',
    component: () => import('@/pages/Home/index.vue'),
  },
]
const router = new VueRouter({
  routes,
})

export default router
